var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardIconBloc',{attrs:{"icon":"check-square-fill","backColor":"rgb(234,230,255)","frontColor":"rgb(82,67,170)"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }